// extracted by mini-css-extract-plugin
module.exports =  {"tooltipBeakVisible":"false","tooltipGapSpace":"10"};